webpackJsonp([12],{

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(598)

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(658),
  /* scopeId */
  "data-v-92a19f00",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			categoryList: [],
			table: {
				list: [],
				page: Number(this.$route.query.page) || 1,
				size: 15,
				total: 0
			},
			newsCondition: [{ name: '热门推荐', key: 'HOST' }],
			q: this.$route.query.q || '',
			k: this.$route.query.k || '',
			s: this.$route.query.s || '' };
	},
	mounted: function mounted() {
		this.initCategory();
		if (this.s) {
			this.initByKeyword();
		} else {
			this.initNews();
		}
	},

	watch: {
		$route: function $route() {
			this.s = this.$route.query.s;
			if (this.s) {
				this.initByKeyword();
			} else {
				this.initNews();
			}
		}
	},
	methods: {
		initCategory: function initCategory() {
			var _this = this;

			this.$http.get('/nc/list', {
				params: {
					fe: 1
				}
			}).then(function (response) {
				_this.categoryList = response.data.data;
				_this.categoryList.unshift({
					name: '全部',
					id: ''
				});
			}).catch(function (err) {});
		},
		filterNews: function filterNews(conditions) {
			if (typeof conditions == 'number') {
				this.q = conditions;
				this.k = '';
				this.$router.push({
					path: this.$route.path,
					query: {
						page: this.table.page,
						q: this.q
					}
				});
			} else {
				this.k = conditions;
				this.q = '';
				this.$router.push({
					path: this.$route.path,
					query: {
						page: this.table.page,
						k: this.k
					}
				});
			}
		},
		handlePage: function handlePage(val) {
			this.table.page = val;
			this.$router.push({
				path: this.$route.path,
				query: {
					page: this.table.page,
					q: this.q
				}
			});
		},
		initNews: function initNews() {
			var _this2 = this;

			this.$http.get('/news/list', {
				params: {
					page: this.table.page,
					category: this.q,
					include: 'category',
					fe: 1,
					status: this.k
				}
			}).then(function (res) {
				_this2.table.list = res.data.data;
				var reg = new RegExp("<[^<]*>", "gi");
				_this2.table.list.forEach(function (item, index) {
					item.content = item.content.replace(reg, "");
				});
				_this2.table.page = res.data.meta.pagination.current_page;
				_this2.table.total = res.data.meta.pagination.total;
			}).catch(function (err) {});
		},
		initByKeyword: function initByKeyword() {
			var _this3 = this;

			this.$http.post('/searchNew', {
				keyword: this.s
			}).then(function (res) {
				_this3.table.list = res.data.data;
				_this3.table.page = res.data.meta.pagination.current_page;
				_this3.table.total = res.data.meta.pagination.total;
			}).catch(function (err) {
				console.log(err);
			});
		}
	}
});

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(495)(true);
// imports


// module
exports.push([module.i, "strong[data-v-92a19f00]{font:normal}.container[data-v-92a19f00]{max-width:1200px;margin:16px auto}.category[data-v-92a19f00]{display:inline-block;padding:5px 8px;margin-right:20px;transition:all .2s ease-out}.category.is-active[data-v-92a19f00],.category[data-v-92a19f00]:hover{background:#14a88c;color:#fff;border-radius:3px}.news-containter[data-v-92a19f00]{width:90%;margin:50px auto 0}.news-item[data-v-92a19f00]{height:170px;background:#f7f7f7;padding:20px 34px;position:relative;margin-bottom:20px}.sundry[data-v-92a19f00]{margin-top:13px;margin-bottom:10px}.title[data-v-92a19f00]{font-size:16px}.type[data-v-92a19f00]{font-size:12px;padding:3px 14px;background:#15ccac;color:#fff;border-radius:3px;margin-right:20px;display:inline-block}.time[data-v-92a19f00]{margin-right:20px;color:#999}.browse[data-v-92a19f00]{color:#999}.content[data-v-92a19f00]{color:#666;line-height:22px;font-size:16px;text-indent:2em;height:44px;display:-webkit-box;-webkit-line-clamp:2;overflow:hidden}.content img[data-v-92a19f00]{display:none!important}.read[data-v-92a19f00]{position:absolute;right:34px;bottom:20px;color:#14a88c}.read[data-v-92a19f00]:hover{color:#15ccac}.no-more[data-v-92a19f00]{text-align:center;color:#ccc}@media (max-width:1024px){.content[data-v-92a19f00]{display:none}.news-item[data-v-92a19f00]{height:inherit}.read[data-v-92a19f00]{display:none}.sundry[data-v-92a19f00]{margin-bottom:0}.news-containter[data-v-92a19f00]{margin-top:20px}.mobile-btn[data-v-92a19f00]{position:absolute;width:100%;height:100%;top:0;left:0}}", "", {"version":3,"sources":["/var/www/ccm/web/src/pages/news/news.vue"],"names":[],"mappings":"AACA,wBAAyB,WAAa,CACrC,AACD,4BAA6B,iBAAiB,AAAC,gBAAiB,CAC/D,AACD,2BAA4B,qBAAqB,AAAC,gBAAiB,AAAC,kBAAkB,2BAA6B,CAClH,AACD,sEAAuE,mBAAmB,AAAC,WAAW,AAAC,iBAAkB,CACxH,AACD,kCAAmC,UAAU,AAAC,kBAAmB,CAChE,AACD,4BAA6B,aAAa,AAAC,mBAAmB,AAAC,kBAAkB,AAAC,kBAAmB,AAAC,kBAAmB,CACxH,AACD,yBAA0B,gBAAgB,AAAC,kBAAmB,CAC7D,AACD,wBAAyB,cAAe,CACvC,AACD,uBAAwB,eAAe,AAAC,iBAAiB,AAAC,mBAAoB,AAAC,WAAW,AAAC,kBAAkB,AAAC,kBAAkB,AAAC,oBAAqB,CACrJ,AACD,uBAAwB,kBAAkB,AAAC,UAAW,CACrD,AACD,yBAA0B,UAAW,CACpC,AACD,0BAA2B,WAAW,AAAC,iBAAiB,AAAC,eAAe,AAAC,gBAAiB,AACxF,YAAY,AACN,oBAAqB,AACrB,qBAAsB,AACtB,eAAiB,CACxB,AACD,8BAA+B,sBAAwB,CACtD,AACD,uBAAwB,kBAAmB,AAAC,WAAW,AAAC,YAAY,AAAC,aAAc,CAClF,AACD,6BAA8B,aAAc,CAC3C,AACD,0BAA2B,kBAAkB,AAAC,UAAW,CACxD,AACD,0BACA,0BAA2B,YAAa,CACvC,AACD,4BAA6B,cAAe,CAC3C,AACD,uBAAwB,YAAa,CACpC,AACD,yBAA0B,eAAgB,CACzC,AACD,kCAAmC,eAAgB,CAClD,AACD,6BAA8B,kBAAmB,AAAC,WAAW,AAAC,YAAY,AAAC,MAAM,AAAC,MAAO,CACxF,CACA","file":"news.vue","sourcesContent":["\nstrong[data-v-92a19f00]{ font: normal;\n}\n.container[data-v-92a19f00]{ max-width:1200px; margin:16px auto;\n}\n.category[data-v-92a19f00]{ display:inline-block; padding: 5px 8px; margin-right:20px;transition:all 0.2s ease-out;\n}\n.category[data-v-92a19f00]:hover,.category.is-active[data-v-92a19f00]{ background:#14a88c; color:#fff; border-radius:3px;\n}\n.news-containter[data-v-92a19f00]{ width:90%; margin:50px auto 0;\n}\n.news-item[data-v-92a19f00]{ height:170px; background:#f7f7f7; padding:20px 34px; position: relative; margin-bottom:20px;\n}\n.sundry[data-v-92a19f00]{ margin-top:13px; margin-bottom:10px;\n}\n.title[data-v-92a19f00]{ font-size:16px;\n}\n.type[data-v-92a19f00]{ font-size:12px; padding:3px 14px; background: #15ccac; color:#fff; border-radius:3px; margin-right:20px; display:inline-block;\n}\n.time[data-v-92a19f00]{ margin-right:20px; color:#999;\n}\n.browse[data-v-92a19f00]{ color:#999;\n}\n.content[data-v-92a19f00]{ color:#666; line-height:22px; font-size:16px; text-indent: 2em;\n\t\theight:44px;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        overflow: hidden;\n}\n.content img[data-v-92a19f00]{ display:none !important;\n}\n.read[data-v-92a19f00]{ position: absolute; right:34px; bottom:20px; color:#14a88c;\n}\n.read[data-v-92a19f00]:hover{ color:#15ccac;\n}\n.no-more[data-v-92a19f00]{ text-align:center; color:#ccc;\n}\n@media (max-width: 1024px){\n.content[data-v-92a19f00]{ display:none;\n}\n.news-item[data-v-92a19f00]{ height:inherit;\n}\n.read[data-v-92a19f00]{ display:none;\n}\n.sundry[data-v-92a19f00]{ margin-bottom:0;\n}\n.news-containter[data-v-92a19f00]{ margin-top:20px;\n}\n.mobile-btn[data-v-92a19f00]{ position: absolute; width:100%; height:100%; top:0; left:0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(584);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(496)("231e8812", content, true);

/***/ }),

/***/ 658:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('Card', {
    staticClass: "no-shadow",
    staticStyle: {
      "width": "90%",
      "margin": "0 auto"
    }
  }, [_vm._l((_vm.categoryList), function(category) {
    return _c('a', {
      staticClass: "category",
      class: {
        'is-active': category.id == _vm.q && !_vm.k
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.filterNews(category.id)
        }
      }
    }, [_vm._v(_vm._s(category.name))])
  }), _vm._v(" "), _vm._l((_vm.newsCondition), function(item) {
    return _c('a', {
      staticClass: "category",
      class: {
        'is-active': item.key == _vm.k
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.filterNews(item.key)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "news-containter"
  }, [_vm._l((_vm.table.list), function(item) {
    return (_vm.table.total != 0) ? _c('div', {
      staticClass: "news-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "sundry"
    }, [(item.category) ? _c('span', {
      staticClass: "type"
    }, [_vm._v(_vm._s(item.category ? item.category.data.name : ''))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.inTimes))]), _vm._v(" "), _c('span', {
      staticClass: "browse"
    }, [_c('Icon', {
      attrs: {
        "type": "eye",
        "size": "14"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.browse_number))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('a', {
      staticClass: "read",
      attrs: {
        "href": '/news-content?q=' + item.id
      }
    }, [_vm._v("阅读全文")]), _vm._v(" "), _c('a', {
      staticClass: "mobile-btn",
      attrs: {
        "href": '/news-content?q=' + item.id
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.table.total == 0) ? _c('div', {
    staticClass: "no-more"
  }, [_vm._v("暂无相关新闻")]) : _vm._e()], 2), _vm._v(" "), _c('Page', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.table.total != 0),
      expression: "table.total != 0"
    }],
    staticClass: "pagination",
    attrs: {
      "current": _vm.table.page,
      "total": _vm.table.total,
      "page-size": _vm.table.size,
      "size": "small"
    },
    on: {
      "on-change": _vm.handlePage
    }
  })], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/12.8a324d58255cbcdd7d6b.js